module.exports = __webpack_public_path__ + "img/O_bright.f5b567a7.svg";